<div class="container-1">
  <div class="h ml-0">Настройки</div>
  @if (model.auth()) {
  <div class="section">
    <p>{{text.of('settings Snippets config')}}</p>
    <div class="row noborder">
      <input [(ngModel)]="snippetsGroupsNewName" [placeholder]="text.of('settings New Snippets group name')" type="text" class="inp-1" />
      <button class="btn-1" (click)="snippetsGroupsCreateClick()">{{text.of('Create')}}</button>
      <!-- <button class="btn-1" (click)="settingsButtonClick()">CONFIG</button> -->
    </div>
    @for (g of model.snippetsGroups; track g; let i = $index) {
      <div class="row snippets-groups">
        @if (g.state!=ItemStates.Edit) {
          <span class="name">{{g.txtValue}}</span>
        }
        @if (g.state==ItemStates.Edit) {
          <input [(ngModel)]="snippetsGroupsEditItem.txtValue" placeholder="имя группы" type="text" class="inp-1" />
        }
        @if (g.state!=ItemStates.Edit) {
          <span>{{g.isArchive?'архив':''}}&nbsp;</span>
        }
        @if (g.state==ItemStates.Edit) {
          <label [for]="'isArchive'+i">&nbsp;&nbsp;&nbsp;архив&nbsp;&nbsp;&nbsp;</label>
        }
        @if (g.state==ItemStates.Edit) {
          <input [id]="'isArchive'+i" type="checkbox" [(ngModel)]="snippetsGroupsEditItem.isArchive" />
        }
        <!-- <span *ngIf="g.state!=ItemStates.Edit">{{g.codeEditor}}&nbsp;</span>
        <span *ngIf="g.state==ItemStates.Edit">&nbsp;&nbsp;&nbsp;язык&nbsp;&nbsp;&nbsp;</span>
        <select *ngIf="g.state==ItemStates.Edit" [(ngModel)]="snippetsGroupsEditItem.codeEditor" class="select-small">
          <option value="">Не выбран</option>
          <option *ngFor="let m of Constants.aceModes" [value]="m">{{m}}</option>
        </select>&nbsp; -->
        @if (g.state!=ItemStates.Edit) {
          <button class="btn-1" (click)="snippetsGroupsEditClick(g)">Изменить</button>
        }
        @if (g.state==ItemStates.Edit) {
          <button class="btn-1" (click)="snippetsGroupsSaveClick(g)">Сохранить</button>
        }
        @if (g.state==ItemStates.Edit) {
          <button class="btn-1" (click)="snippetsGroupsCancelClick(g)">Отмена</button>
        }
        @if (![ItemStates.Edit,ItemStates.Deleting].includes(g.state)) {
          <button class="btn-1" (click)="snippetsGroupsDelete(g)">Удалить</button>
        }
      </div>
    }
  </div>
}
  <p></p>

  <div>
    <div class="h mb-1">{{text.of('settings Code config')}}</div>
        @if(model.helpVisible()){
    <div class="help-text mt-0 mb-1">
Конфигурация подстановок:<br>
"..camelFirstLower.." - кэмэл кейз с первой буквой в нижнем регистре;<br>
"..CamelFirstUpper.." - кэмэл кейз с первой буквой в верхнем регистре;<br>
"..Kebab.." - кебаб кейз;
    </div>
    }
    <textarea rows="20" [(ngModel)]="model.patternsArrayTextareaVal"></textarea>
    <div class="row noborder">
      <button class="btn-1 ml-0" (click)="settingsBlockSaveClick()">{{text.of('Save')}}</button>
      <button class="btn-1 ml-1" (click)="settingsBlockResetClick()">Сброс</button>      
    </div>
  </div>
</div>

